import { Alert, Button, Col, Form, Input, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { StyledFormItem } from '../../components/styledComponents';
import { AppDispatch } from '../../redux/root/root.store';
import { AuthSliceMethods, getAuthState } from '../../redux/slices/authSlice';
import { Paths } from '../../paths';

const StyledForm = styled(Form)`
  width: 400px;
  margin: 97px auto 0;  
  background: #ffffff;
  padding: 2em;
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  box-shadow: 0px 4px 30px 0px #B5B7C033;
`;
const LoginPage = styled.div`
  width: 100%;
  height: 100vh;

`;
const InputLogin = styled(Input)`
  background: #ffffff;
  box-shadow: 0px 6px 46px rgba(0, 0, 0, 0.05);
  border-radius: 16px;
  padding: 10px 12px;
`;
const InputLoginPas = styled(Input.Password)`
  background: #ffffff;
  box-shadow: 0px 6px 46px rgba(0, 0, 0, 0.05);
  border-radius: 16px;
  padding: 10px 12px;
`;
const ButtonLogin = styled(Button)`
  padding: 26px 24px;
  background: #3e4684;
  color: white;
  border: none;
  border-radius: 16px;
  font-weight: 600;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
`;
const TitleLogin = styled.h3`
font-family: Montserrat;
font-size: 22px;
font-weight: 600;
line-height: 26.82px;
 color:#6B6767;
  text-align: center;
`;
const TextLogin = styled.p`
font-family: Montserrat;
font-size: 14px;
font-weight: 400;
line-height: 17.07px;
text-align: center;
 color:#6B6767;
 margin: 20px 0
`;
const FormBlock = styled.div`
 min-height: 100vh
`;
const FormBlockGreen = styled.div`
    min-height: 100vh;
    background-image: url(./assets/loginbg.png);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
`;

export const Login = () => {
  const [form] = useForm();
  const { errorMessage } = useSelector(getAuthState);
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      await form.validateFields();
    } catch (ex: any) {
      return;
    }
    await dispatch(AuthSliceMethods.login({ username: form.getFieldValue('username'), password: form.getFieldValue('password') })).then(async (_: any) => {
      const response: any = await dispatch(AuthSliceMethods.getUserInfo());
      if (response.payload) {
        if (!response.payload.changePasswordNextLogon) {
          navigate(Paths.home, { replace: false });
        } else {
          navigate(Paths.changePassword, { replace: false });
        }
      }
    });
  };

  return (
    <LoginPage >
      <Row style={{ margin: 0 }} gutter={16}>
        <Col className="gutter-row" span={14}>
          <FormBlock>
            <div>
              <Row style={{ margin: 0 }} gutter={16}>

              </Row>
            </div>
            <StyledForm
              form={form}
              className="form_login"
              name="basic"
              initialValues={{ remember: true }}
              autoComplete="off"
              layout="vertical"
            >
              <TitleLogin>
                Войдите в систему

              </TitleLogin>
              <TextLogin>
                Добро пожаловать в систему!
                Пожалуйста, введите свои учетные данные для доступа
              </TextLogin>
              <StyledFormItem
                label="Логин"
                name="username"
                rules={[{ required: true, message: "Толтуруу/Заполнить" }]}
              >
                <InputLogin
                  className="login_input"
                />
              </StyledFormItem>
              <StyledFormItem
                label="Сыр сөз/Пароль"
                name="password"
                rules={[{ required: true, message: 'Толтуруу/Заполнить' }]}
              >
                <InputLoginPas />
              </StyledFormItem>
              {errorMessage !== "" && <Alert message={errorMessage} type='error' showIcon style={{ marginBottom: 10 }} />}
              <ButtonLogin type="primary" htmlType="submit" onClick={handleLogin}>
                Кирүү/Войти
              </ButtonLogin>
            </StyledForm>
          </FormBlock>

        </Col>
        <Col className="gutter-row" span={10}>
          <FormBlockGreen></FormBlockGreen>
        </Col>
      </Row>

    </LoginPage>
  )
}
